import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface EditEducationForCandidateResponse extends BackendResponse {}
export interface EditEducationForCandidateParameters extends NextApiParams {
  educationId: number;
  from: string;
  to: string;
  firmId: number;
  comment: string;
  references: string;
  school: string;
  educationType: number;
  expirationDate: string | null;
}

export const editEducationForCandidate = withNextApi<
  EditEducationForCandidateResponse,
  EditEducationForCandidateParameters
>("/cvp/CvpEditEducationForCandidate");
